// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9DM8W","input":"styles_input__yDtrI"};